module.exports = __webpack_public_path__ + "static/media/S (97).3039c498.jpg";